import { h } from 'preact';
import * as BaseComp from 'components/shared/simpleVideoPlayer/simpleVideoPlayer.js';
// import s from 'components/shared/simpleVideoPlayer/simpleVideoPlayer.sss';

export default class SimpleVideoPlayer extends BaseComp.default {
	togglePlay = () => {
		if (this.props.disableInteraction) {
			return;
		}

		if (!this.state.playing) {
			this.play();
			this.props.handlePosterClick();
		} else {
			this.pause();
			this.props.handlePosterClick();
		}
	}
}
